import {Pipe, PipeTransform} from '@angular/core';
import {xml as xmlBeautify, json as jsonBeautify} from 'vkbeautify';

enum Type {
  JSON = 'json',
  XML = 'xml'
}

@Pipe({
  name: 'prettyPrintText'
})
export class PrettyPrintTextPipe implements PipeTransform {

  transform(text: string, type: string | Type = Type.XML, whitespaces: number = 2): string {
    const formattedText = this.format(text, type, whitespaces);

    return type === Type.JSON
      ? this.highlightJson(formattedText)
      : type === Type.XML
        ? this.highlightXml(formattedText)
        : this.escapeHtml(formattedText);
  }

  private format(text: string, type: string | Type, whitespaces: number): string {
    if (type === Type.XML) {
      return xmlBeautify(text, whitespaces);
    }
    if (type === Type.JSON) {
      return jsonBeautify(text, whitespaces);
    }
    return text;
  }

  private highlightJson(text: string): string {
    const escapedText = this.escapeHtml(text);
    const stringPattern = '&quot;(?:\\\\.|(?!&quot;)[^\\\\])*&quot;';
    const tokenPattern = new RegExp(`(${stringPattern})(?=\\s*:)|(${stringPattern})|(-?\\d+(?:\\.\\d+)?(?:[eE][+-]?\\d+)?)|\\b(true|false|null)\\b`, 'g');

    return escapedText.replace(tokenPattern, (match, key, stringValue, number, literal) => {
      const tokenType = key ? 'key' : stringValue ? 'string' : number ? 'number' : 'literal';
      return `<span class="content-display-token content-display-token-${tokenType}">${match}</span>`;
    });
  }

  private highlightXml(text: string): string {
    const escapedText = this.escapeHtml(text);
    const commentPattern = /(&lt;!--[\s\S]*?--&gt;)/g;

    return escapedText.split(commentPattern).map((segment, index) => {
      return index % 2 === 1
        ? `<span class="content-display-token content-display-token-comment">${segment}</span>`
        : this.highlightXmlTags(segment);
    }).join('');
  }

  private highlightXmlTags(text: string): string {
    return text.replace(/(&lt;\/?)([A-Za-z_][\w:.-]*)([\s\S]*?)(\/?&gt;)/g, (_match, opening, tagName, attributes, closing) => {
      const highlightedAttributes = attributes.replace(
        /([A-Za-z_][\w:.-]*)(=)(&quot;(?:\\.|(?!&quot;)[^\\])*&quot;)/g,
        '<span class="content-display-token content-display-token-attribute">$1</span>$2<span class="content-display-token content-display-token-string">$3</span>'
      );

      return `${opening}<span class="content-display-token content-display-token-tag">${tagName}</span>${highlightedAttributes}${closing}`;
    });
  }

  private escapeHtml(text: string): string {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
}
